module.exports = __webpack_public_path__ + "static/media/ico-close-interno.b912fbd2.svg";